import { createFileRoute, Outlet } from '@tanstack/react-router';
import { useLingui } from '@lingui/react/macro';
import { trpc } from '@/lib/trpc';
import { Header } from './-components/header';
import { Footer } from './-components/footer';
import { Layout } from './-components/layout';
import { PageSeo } from './-components/page-seo';
import { slugs } from './partner-ngos.meta';
import { Hero } from './-components/partner-ngos/hero';
import { NgoDirectory } from './-components/partner-ngos/ngo-directory';
import { Testimonials } from './-components/partner-ngos/testimonials';
import { HowToCollaborate } from './-components/partner-ngos/how-to-collaborate';
import { NgoAreaBand } from './-components/partner-ngos/ngo-area-band';
import { Faq, useFaqItems } from './-components/partner-ngos/faq';

export const Route = createFileRoute('/www/partner-ngos')({
	loader: ({ context }) => {
		// `prefetchQuery`, not `ensureQueryData`: see the homepage loader.
		context.queryClient.prefetchQuery(trpc.portal.getPartnerNgos.queryOptions());
		context.queryClient.prefetchQuery(trpc.portal.getWorldcooGlobalStats.queryOptions());
	},
	component: Component,
});

function Component() {
	const { t } = useLingui();
	const faqItems = useFaqItems();

	// The accordion's own array, so the markup never answers a question the page does not show.
	const faqLd = {
		'@context': 'https://schema.org',
		'@type': 'FAQPage',
		'mainEntity': faqItems.map((item) => ({
			'@type': 'Question',
			'name': item.question,
			// Flattened, or the rich result quotes only the sentence introducing the list.
			'acceptedAnswer': {
				'@type': 'Answer',
				'text': item.bullets ? `${item.answer} ${item.bullets.join(' ')}` : item.answer,
			},
		})),
	};

	return (
		<Layout>
			<Header />
			<PageSeo
				slugs={slugs}
				title={t`Partner NGOs - Worldcoo`}
				description={t`The social entities we work with to turn microdonations into funded projects. Discover the NGOs that are part of Worldcoo and how to start collaborating.`}
				jsonLd={[faqLd]}
			/>
			<Hero />
			{/* Owns its Suspense and error boundary, so the static heading renders either way. */}
			<NgoDirectory />
			{/* No UI, but unrendered the router warns about the child match. */}
			<Outlet />
			<Testimonials />
			<HowToCollaborate />
			<NgoAreaBand />
			<Faq />
			<Footer cta="form" formVariant="ngo" />
		</Layout>
	);
}
